export default __webpack_public_path__ + "static/83-f159358b2428cca8f4d166709ab80f3b.png";